"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmraPasswordResetRequestSchema () {
        return EmraPasswordResetRequestSchema;
    },
    get PasswordResetConfirmSchema () {
        return PasswordResetConfirmSchema;
    },
    get PasswordResetRequestSchema () {
        return PasswordResetRequestSchema;
    }
});
const _zod = require("zod");
const _email = require("./email");
const PasswordResetRequestSchema = _zod.z.object({
    email: _email.EmailAddressSchema
});
const PasswordResetConfirmSchema = _zod.z.object({
    token: _zod.z.string().min(1),
    newPassword: _zod.z.string().min(12).max(256)
});
const EmraPasswordResetRequestSchema = _zod.z.object({
    tenantSlug: _zod.z.string().min(1),
    email: _email.EmailAddressSchema
});
